export const toggleValue = <T>(newValue: T, prevValue: T): T | undefined =>
  newValue === prevValue ? undefined : newValue;
